import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import './input.css';

class Input extends React.PureComponent {
  render() {
    const {
      type,
      label,
      value,
      maxLength,
      errorText,
      width,
      helpText,
      onBlur,
      onChange,
      onFocus,
      disabled
    } = this.props;

    return (
      <Form.Group controlId="input">
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Control
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          maxLength={maxLength}
          isInvalid={!!errorText}
          style={{ width }}
          type={type}
          disabled={disabled}
        />
        {errorText ? (
          <Form.Control.Feedback type="invalid">
            {errorText}
          </Form.Control.Feedback>
        ) : (
          <Form.Text>{helpText}</Form.Text>
        )}
      </Form.Group>
    );
  }
}

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  width: PropTypes.string.isRequired,
  helpText: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.string
};

Input.defaultProps = {
  type: 'text',
  label: undefined,
  errorText: '',
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {}
};

export default Input;
